module.exports = __webpack_public_path__ + "img/log-bottom.9c24d8f3.png";